import React from "react";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import { Lock, HelpCircle } from "react-feather";
import {
  Row,
  Col,
  Modal,
  Card,
  Form,
  Input,
  Label,
  Button,
  Spinner,
  CardBody,
  ModalBody,
  InputGroup,
  ModalHeader,
  InputGroupText,
  FormGroup,
  CardImg,
  UncontrolledTooltip,
} from "reactstrap";

import { productImage, validAlphaNumeric } from "../../../utilities";
import {
  fetchUpdateProduct,
  fetchProduct,
  clearUpdatedProductData,
  fetchProducts,
} from "../productActions";
import { receiveValidationErrors } from "../../../Shared/Errors/errorActions";
import EditProductImage from "./EditProductImage";
/* eslint-disable */

class EditProduct extends React.Component {
  constructor(props) {
    super(props);
    const { product_id } = props;
    const i = props.products
      ? props.products.findIndex(
          ({ _id, name }) => product_id === _id || product_id === name
        )
      : null;
    const product = i === -1 ? {} : props.products[i];
    this.state = {
      upc: product.upc || "",
      productDescription: product.desc || "",
      productHeading: product.name || "",
      updated: false,
      image: productImage(product, props.pictures) || null,
      updatedImage: null,
      imageDeleted: false,
    };
  }

  componentWillMount() {
    const { dispatch } = this.props;
    const errors = {};
    dispatch(receiveValidationErrors(errors));
  }

  _validateProductForm = () => {
    const { upc, productDescription } = this.state;
    const { dispatch } = this.props;
    let isValid = false;
    const errors = {};
    if (!upc) {
    } else if (!validAlphaNumeric(upc) || upc.length > 13) {
      errors.upc =
        "Only alphanumeric values are allowed for UPC code with a maximum length of 13 characters.";
    }

    if (productDescription && productDescription.length > 5000) {
      errors.productDescription =
        "Product Description can't exceed 5000 characters.";
    }

    if (isEmpty(errors)) {
      isValid = true;
      dispatch(receiveValidationErrors(errors));
    } else {
      dispatch(receiveValidationErrors(errors));
    }
    return isValid;
  };

  update = (event) => {
    const { target } = event;
    const value = target.value;
    const { name } = target;
    this.setState({ [name]: value });
  };

  updateProduct = (product_id) => {
    const { dispatch } = this.props;
    const formData = new FormData();
    formData.append("upc_code", this.state.upc);
    formData.append("description", this.state.productDescription);
    formData.append("product_heading", this.state.productHeading);
    if (this.state.updatedImage) {
      formData.append("picture", this.state.updatedImage);
    }
    if (!this.state.updatedImage && this.state.imageDeleted) {
      formData.append("picture", "delete");
    }
    if (this._validateProductForm()) {
      dispatch(fetchUpdateProduct(product_id, formData));
      this.setState({ updated: true });
    }
  };

  closeModal = (product_id) => {
    const { dispatch, showProductEdit, params, updateProduct } = this.props;
    dispatch(fetchProduct(product_id));
    dispatch(clearUpdatedProductData());
    if (updateProduct.success) {
      dispatch(fetchProducts(params));
    }
    showProductEdit;
  };

  updateImage = (image) => {
    this.setState({ updatedImage: image });
  };

  deleteImage = () => {
    if (this.state.updatedImage) {
      this.setState({ updatedImage: null });
    }
    if (this.state.image) {
      this.setState({ image: null, imageDeleted: true });
    }
  };

  render() {
    const {
      products,
      open,
      product_id,
      showProductEdit,
      pictures,
      loading,
      validationErrors,
      updateProduct,
      tab,
    } = this.props;
    const i = products.findIndex(
      ({ _id, name }) => product_id === _id || product_id === name
    );
    const product = i === -1 ? {} : products[i];
    const image = productImage(product, pictures);
    const invalidMessage = {
      fontSize: "11px",
      color: "red",
    };
    return (
      <Modal
        size="lg"
        isOpen={open}
        toggle={
          this.state.updated
            ? () => this.closeModal(product_id)
            : showProductEdit
        }
        className="modal-dialog-centered"
      >
        <ModalHeader
          toggle={
            this.state.updated
              ? () => this.closeModal(product_id)
              : showProductEdit
          }
          cssModule={{ "modal-title": "h4" }}
        >
          Edit Product
        </ModalHeader>
        <ModalBody>
          {updateProduct.loading && (
            <div style={{ textAlign: "center", margin: "268px auto" }}>
              <div>
                <Spinner className="m-1" />
              </div>
              Please wait, Running AVA<br></br> and fetching new videos of the
              product/hashtag
            </div>
          )}
          {updateProduct.success && (
            <div className="d-flex flex-column mb-3 align-items-center">
              <div className="p-2">
                <Card>
                  <CardBody className="align-self-center">
                    <CardImg
                      style={{ maxHeight: "270px" }}
                      src={
                        (this.state.updatedImage &&
                          this.state.updatedImage.preview) ||
                        this.state.image ||
                        require("@src/assets/images/vyrill/default.png").default
                      }
                    />
                  </CardBody>
                </Card>
              </div>
              <div className="p-1">
                <h3 className="text-align-center">
                  Your product have been updated
                </h3>
              </div>
              <div className="p-1">
                <Button
                  className="me-1"
                  onClick={() => this.closeModal(product_id)}
                  color="primary"
                  type="submit"
                >
                  Close
                </Button>
              </div>
            </div>
          )}
          {!updateProduct.loading && !updateProduct.success && (
            <>
              <Form>
                <Row>
                  <Col sm="12">
                    <Label className="form-label" for="nameVerticalIcons">
                      Product Name
                    </Label>
                    <InputGroup className="input-group-merge mb-1">
                      <Input
                        type="text"
                        name="productHeading"
                        id="nameVerticalIcons"
                        value={this.state.productHeading}
                        onChange={this.update}
                        placeholder="Product Name"
                      />
                    </InputGroup>
                  </Col>

                  <Col sm="12" className=" mb-1">
                    <InputGroup className="input-group-merge">
                      <Input
                        name="upc"
                        placeholder="UPC Code"
                        onChange={this.update}
                        invalid={
                          validationErrors && validationErrors.upc
                            ? true
                            : false
                        }
                        value={this.state.upc}
                        maxLength="13"
                      />
                      <InputGroupText>
                        <HelpCircle id="msg" size={15} />
                      </InputGroupText>
                      <UncontrolledTooltip placement="left" target="msg">
                        The UPC code is the reference number from your product.
                        Add the same one you have on your Shopify store to
                        display your videos on the store
                      </UncontrolledTooltip>
                    </InputGroup>
                    {validationErrors && validationErrors.upc ? (
                      <span style={invalidMessage}>{validationErrors.upc}</span>
                    ) : (
                      ""
                    )}
                  </Col>

                  <Col sm="12" className="mb-2">
                    <div>
                      <Label for="textarea">Description</Label>
                      <Input
                        id="textarea"
                        type="textarea"
                        name="productDescription"
                        invalid={
                          validationErrors &&
                          validationErrors.productDescription
                            ? true
                            : false
                        }
                        onChange={this.update}
                        value={this.state.productDescription}
                      />
                    </div>
                    {validationErrors && validationErrors.productDescription ? (
                      <span style={invalidMessage}>
                        {validationErrors.productDescription}
                      </span>
                    ) : (
                      ""
                    )}
                  </Col>
                  <Col sm="12">
                    <Label for="image">Product Image</Label>
                  </Col>
                  {loading ? (
                    <Spinner />
                  ) : (
                    <Col sm="5">
                      <FormGroup>
                        <Card>
                          <EditProductImage
                            image={this.state.image}
                            updatedImage={this.state.updatedImage}
                            updateImage={this.updateImage}
                            deleteImage={this.deleteImage}
                            tab={this.props.params?.tab !== "Competition"}
                          />
                        </Card>
                      </FormGroup>
                    </Col>
                  )}
                </Row>
              </Form>
              <Col sm="12">
                <div className="d-flex">
                  <Button
                    className="me-1"
                    onClick={() => this.updateProduct(product_id)}
                    color="primary"
                    type="submit"
                  >
                    Save
                  </Button>
                  <Button
                    outline
                    color="secondary"
                    onClick={showProductEdit}
                    type="reset"
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </>
          )}
        </ModalBody>
      </Modal>
    );
  }
}

const mapStateToProps = ({
  errors,
  products,
  productData,
  updateProduct,
  productParams,
}) => ({
  products,
  pictures: productData.pictures,
  validationErrors: errors.validationErrors,
  updateProduct,
  params: productParams,
});

export default connect(mapStateToProps)(EditProduct);
